export enum FindAllUsersSort {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  CREATED_DATE = 'createdDate',
  UPDATED_DATE = 'updatedDate',
}
